export default __webpack_public_path__ + "static/media/border-tip-right.5b25a385.png";